import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class HotelService {
  constructor(private httpClient: HttpClient) {}
  private hotelOpen: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  getActiveInterface() {
    return this.hotelOpen.value;
  }


  setActiveInterface(value: number) {
    this.hotelOpen.next(value);
  }
}
